import { Grid, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { calculateAccountMetrics } from '../../components/footer/AccountCalculation';
import { ThemeContext } from '../../context/ThemeContext';
import { shallowEqual, useSelector } from 'react-redux';
import { profitLoss } from '../../components/footer/AccountFooter';
import { useTranslation } from 'react-i18next';



const AccountSummary = () => {
    const { accountSummary } = useSelector(state => state.accountSummary, shallowEqual);
    const { updatePL } = useSelector((state) => state.profitLoss);
    const { calculatedEquity, calculatedMarginLevel, freeMargin } = calculateAccountMetrics(accountSummary);
    const { darkMode } = useContext(ThemeContext)
    const [floatingPL, setFloatingPL] = useState(0)
    const {t} = useTranslation()

    const formatted = (val) =>
        (val || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    const InfoRow = ({ label, value }) => (
        <Grid item xs={6}>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography variant="body2" color="text.secondary" >{t(label)}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" sx={{ color: darkMode ? "var(--white)" : 'var(--black)' }}>{value}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
    const infoItems = [
        { label: 'balance', value: formatted(accountSummary?.balance) },
        { label: 'freeMargin', value: formatted(freeMargin) },
        { label: 'equity', value: formatted(calculatedEquity) },
        { label: 'usedMargin', value: formatted(accountSummary?.usedMargin) },
        { label: 'credit', value: formatted(accountSummary?.credit) },
        { label: 'marginLevel', value: `${calculatedMarginLevel.toFixed(2)}%` },
    ];

    // useEffect(() => {
    //     const selectedSLTPs = orderSLTP?.filter(sltp => sltp.positionId === selectedPosition?.id) || [];
    //     const sl = selectedSLTPs.map(s => s.stopLoss).join(', ') || '0.00';
    //     const tp = selectedSLTPs.map(s => s.takeProfit).join(', ') || '0.00';
    //     setStopLosses(sl);
    //     setTakeProfits(tp);
    // }, [orderSLTP, positions])
    useEffect(() => {
        let pl = 0;
        if ([...profitLoss].length <= 0) {
            setFloatingPL(0);
            return;
        }
        [...profitLoss].map(item => {
            pl += parseFloat(item[1]) || 0
        })
        setFloatingPL(pl)
    }, [updatePL])
    return (
        <>
            <Typography variant="h6" color="error" align="center" fontWeight="bold" mb={2}>{parseFloat(floatingPL).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
            <Grid container spacing={1} mb={1} p={1}>
                {infoItems.map((item, index) => (
                    <InfoRow key={index} label={item.label} value={item.value} />
                ))}
            </Grid>
        </>
    )
}

export default AccountSummary
